import { NativeSelect } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { AttributeWrapper } from "./AttributeWrapper";
import { CraAttributeSelect, CraAttributeSelectOption } from "@keita/lanepatrol-sdk";
import { CraAttributeUtils } from "../../../../../../coding/utils/attribute-utils";
import {
  getAttributeValue,
  parseAttributeInputValue,
} from "../../../../../../coding/utils/attribute-value";
import { useStores } from "../../../../../../shared/stores/RootStore";
import { useAttributeHighlight } from "../../hooks/useAttributeHighlight";
import { OsaNodeCoding } from "../../../../../../coding/models/OsaNodeCoding";

const SelectAttributeBase = ({
  attributeDefinition,
  disabled,
  compact,
  nodeCoding,
}: {
  attributeDefinition: CraAttributeSelect;
  disabled: boolean;
  compact: boolean;
  nodeCoding: OsaNodeCoding;
}) => {
  const { codingStore } = useStores();
  const highlighted = useAttributeHighlight(attributeDefinition);

  if (disabled) return null;

  const existingValue = getAttributeValue(
    attributeDefinition.name,
    nodeCoding.attributes,
  );
  const inputValue = existingValue ? (existingValue as string) : "";

  const onSelect = (value: string) => {
    const parsedValue = parseAttributeInputValue(attributeDefinition, value);

    codingStore.codeAttribute(attributeDefinition.name, parsedValue);
  };

  return (
    <AttributeWrapper
      compact={compact}
      attributeDefinition={attributeDefinition}
      label={CraAttributeUtils.getLabel(attributeDefinition.name)}
    >
      {!disabled && (
        <NativeSelect.Root
          transitionDuration="0.2s"
          bgColor={highlighted ? `primary.100` : "white"}
          size="xs"
          fontSize={compact ? "xs" : "md"}
        >
          <NativeSelect.Field
            value={inputValue}
            onChange={(e) => onSelect(e.target.value)}
            placeholder="Choose a value"
          >
            {attributeDefinition.options &&
              attributeDefinition.options!.map((option, i) => {
                option as CraAttributeSelectOption;
                return (
                  <option key={i} value={option.value}>
                    {CraAttributeUtils.getOptionLabel(option.value)}
                  </option>
                );
              })}
          </NativeSelect.Field>
          <NativeSelect.Indicator />
        </NativeSelect.Root>
      )}
    </AttributeWrapper>
  );
};
export const SelectAttribute = observer(SelectAttributeBase);
